(function(){
  var M=window.BF_META,SH=window.BF_SHEETS||[],NF=M.n,NS=SH.length;
  var W=M.w,Hh=M.h,track=document.getElementById('track'),prod=document.getElementById('prod'),chaps=[].slice.call(document.querySelectorAll('.chap')),ticks=[].slice.call(document.querySelectorAll('.rail i')),hint=document.getElementById('hint'),cv=document.getElementById('pc'),N=chaps.length,p=0,sp=0,lastPos=-1,cur=-1,tPrev=0,lastCs=-1;
  var ctx=cv?cv.getContext('2d'):null;if(cv){cv.width=W;cv.height=Hh}if(!cv||!SH.some(Boolean))prod.classList.add('show');
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IMG=[];
  function load(s){if(!SH[s]||IMG[s])return;var i=new Image();i.decoding='async';i.src=SH[s];IMG[s]=i;
    (i.decode?i.decode():Promise.resolve()).then(function(){i._ok=1;if(s===0)prod.classList.add('show');lastPos=-1}).catch(function(){i._ok=1;lastPos=-1})}
  function drop(s){if(IMG[s]){IMG[s].src='';IMG[s]=null}}
  function keepAround(cs){for(var s=0;s<NS;s++){var d=Math.min(Math.abs(s-cs),NS-Math.abs(s-cs));if(d<=1)load(s);else if(d>=3)drop(s)}}
  function src(idx){idx=((idx%NF)+NF)%NF;var s=Math.floor(idx/M.per),k=idx%M.per,im=IMG[s];return im&&im._ok&&im.naturalWidth?{im:im,sx:(k%M.cols)*W,sy:Math.floor(k/M.cols)*Hh}:null}
  function near(idx){for(var d=0;d<NF;d++){var r=src(idx-d)||src(idx+d);if(r)return r}return null}
  function progress(){var r=track.getBoundingClientRect(),max=r.height-window.innerHeight;return Math.min(1,Math.max(0,-r.top/max))}
  function ui(){var idx=Math.min(N-1,Math.floor(p*N*0.9999));
    if(idx!==cur){chaps.forEach(function(c,i){c.classList.toggle('on',i===idx)});ticks.forEach(function(t,i){t.classList.toggle('on',i===idx)});cur=idx}
    hint.style.opacity=p<.02?1:0}
  function draw(){
    if(!ctx)return;
    var pos=sp*NF,i=Math.min(NF-1,Math.floor(pos)),cs=Math.floor(i/M.per);
    if(cs!==lastCs){lastCs=cs;keepAround(cs)}
    if(Math.abs(pos-lastPos)<.003)return;
    var t=pos-i,a=src(i),b=src(i+1);
    if(!a&&!b){a=near(i);if(!a)return}
    lastPos=pos;ctx.clearRect(0,0,W,Hh);
    if(a){ctx.globalAlpha=1;ctx.drawImage(a.im,a.sx,a.sy,W,Hh,0,0,W,Hh)}
    if(b&&t>.001){ctx.globalAlpha=a?t:1;ctx.drawImage(b.im,b.sx,b.sy,W,Hh,0,0,W,Hh)}
    ctx.globalAlpha=1;
  }
  function frame(now){
    var dt=Math.min(.05,(now-tPrev)/1000||.016);tPrev=now;
    var d=p-sp;
    if(reduce||Math.abs(d)<.00005)sp=p;else sp+=d*(1-Math.exp(-dt*7));
    draw();requestAnimationFrame(frame)}
  function onScroll(){p=progress();ui()}
  addEventListener('scroll',onScroll,{passive:true});addEventListener('resize',onScroll);onScroll();keepAround(0);requestAnimationFrame(frame);
})();
